'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var InternalSkeleton_web_styles = require('./InternalSkeleton.web.styles.cjs');

/**
 * Internal only skeleton component that allows custom width and height
 *
 * @scope: Core, Internal
 */ const InternalSkeleton = ({ width, height, borderRadius = "medium", isFullWidth = false, customStyles })=>{
    const skeletonStyles = [
        InternalSkeleton_web_styles.baseSkeleton,
        InternalSkeleton_web_styles.borderRadius[borderRadius],
        width && InternalSkeleton_web_styles.customWidth(width),
        height && InternalSkeleton_web_styles.customHeight(height),
        isFullWidth && InternalSkeleton_web_styles.fullWidth,
        customStyles
    ];
    return /*#__PURE__*/ jsxRuntime.jsx("div", {
        css: skeletonStyles,
        "aria-busy": true,
        "data-testid": "aviary-skeleton"
    });
};

exports.InternalSkeleton = InternalSkeleton;
//# sourceMappingURL=InternalSkeleton.web.cjs.map
